import { Badge, makeStyles, Theme } from '@material-ui/core';

type TypeBadgeProps = {
  typeDisplayName: string;
  kind: string;
};

const useStyles = makeStyles<Theme, { kind: string }>(
  theme => ({
    root: props => {
      let bgColor: any = theme.palette.grey[500];

      switch (props.kind) {
        case 'system':
          bgColor = theme.palette.relationsGraph.system;
          break;
        case 'component':
          bgColor = theme.palette.relationsGraph.component;
          break;
        default:
          bgColor = theme.palette.grey[500];
          break;
      }

      const textColor = theme.palette.getContrastText(bgColor);

      return {
        borderRadius: theme.spacing(0.5),
        padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
        ...theme.typography.body2,
        color: textColor,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        backgroundColor: bgColor,
      };
    },
  }),
  { name: 'TypeBadge' },
);

export const TypeBadge = ({ typeDisplayName, kind }: TypeBadgeProps) => {
  const classes = useStyles({ kind });

  return (
    <Badge overlap="rectangular" className={classes.root}>
      {typeDisplayName}
    </Badge>
  );
};
